(function () {
  'use strict';

  var root = document.querySelector('[data-spirit-ai-chat]');
  if (!root || root.__spiritAiReady) return;
  root.__spiritAiReady = true;

  var apiBase = root.getAttribute('data-api-base') || '';
  var sourceUrl = root.getAttribute('data-source-url') || window.location.href;
  var panel = root.querySelector('[data-spirit-ai-panel]');
  var messages = root.querySelector('[data-spirit-ai-messages]');
  var form = root.querySelector('[data-spirit-ai-form]');
  var input = root.querySelector('[data-spirit-ai-input]');
  var openBtn = root.querySelector('[data-spirit-ai-open]');
  var closeBtn = root.querySelector('[data-spirit-ai-close]');
  var greeting = root.querySelector('[data-spirit-ai-greeting]');
  var conversationId = window.localStorage.getItem('spiritAiConversationId') || '';
  var visitorId = window.localStorage.getItem('spiritAiVisitorId') || '';
  var openingVariantId = window.localStorage.getItem('spiritAiOpeningVariant') || '';

  if (!visitorId) {
    visitorId = 'v_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
    window.localStorage.setItem('spiritAiVisitorId', visitorId);
  }

  function track(eventName, payload) {
    if (!apiBase) return;
    fetch(apiBase + '/api/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        conversationId: conversationId || undefined,
        visitorId: visitorId,
        eventName: eventName,
        payload: payload || {}
      })
    }).catch(function () {});
  }

  function formatPrice(product) {
    if (!product || !product.minPrice) return '';
    if (product.maxPrice && product.maxPrice !== product.minPrice) {
      return '$' + product.minPrice + ' - $' + product.maxPrice;
    }
    return '$' + product.minPrice;
  }

  function scrollToBottom() {
    messages.scrollTop = messages.scrollHeight;
  }

  function appendMessage(role, text) {
    var node = document.createElement('div');
    node.className = 'SpiritAiChat__Message SpiritAiChat__Message--' + role;
    node.textContent = text;
    messages.appendChild(node);
    scrollToBottom();
    return node;
  }

  function showTyping() {
    var node = document.createElement('div');
    node.className = 'SpiritAiChat__Message SpiritAiChat__Message--assistant SpiritAiChat__Typing';
    node.setAttribute('aria-label', 'Luma is typing');
    node.innerHTML = '<span class="SpiritAiChat__TypingDots"><i></i><i></i><i></i></span>';
    messages.appendChild(node);
    scrollToBottom();
    return node;
  }

  function appendProducts(products) {
    if (!products || !products.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'SpiritAiChat__Products';

    products.slice(0, 3).forEach(function (product) {
      var card = document.createElement('a');
      card.className = 'SpiritAiChat__Product';
      card.href = product.url;
      card.setAttribute('data-spirit-ai-product', product.handle);

      var img = document.createElement('img');
      img.alt = product.title || '';
      img.loading = 'lazy';
      img.src = product.imageUrl || '';

      var copy = document.createElement('span');
      var title = document.createElement('span');
      title.className = 'SpiritAiChat__ProductTitle';
      title.textContent = product.title || 'View product';
      var meta = document.createElement('span');
      meta.className = 'SpiritAiChat__ProductMeta';
      meta.textContent = formatPrice(product) || 'View details';

      copy.appendChild(title);
      copy.appendChild(meta);
      card.appendChild(img);
      card.appendChild(copy);
      card.addEventListener('click', function () {
        track('product_click', { handle: product.handle, url: product.url });
      });
      wrap.appendChild(card);
    });

    messages.appendChild(wrap);
    scrollToBottom();
  }

  // Fetch the A/B-assigned opening question and render the greeting.
  function loadOpening() {
    if (!apiBase) return;
    fetch(apiBase + '/api/opening?visitorId=' + encodeURIComponent(visitorId))
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data) return;
        if (data.variantId) {
          openingVariantId = data.variantId;
          try { window.localStorage.setItem('spiritAiOpeningVariant', openingVariantId); } catch (e) {}
        }
        if (data.greeting && greeting) greeting.textContent = data.greeting;
      })
      .catch(function () {});
  }

  function setOpen(isOpen) {
    panel.hidden = !isOpen;
    openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    root.classList.toggle('is-open', isOpen);
    if (isOpen) {
      setTimeout(function () { input.focus(); }, 50);
      track('chat_opened', { url: window.location.href });
    }
  }

  function sendMessage(text) {
    var message = String(text || '').trim();
    if (!message || root.classList.contains('is-loading')) return;
    appendMessage('user', message);
    input.value = '';
    root.classList.add('is-loading');
    var typing = showTyping();

    fetch(apiBase + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: message,
        conversationId: conversationId || undefined,
        visitorId: visitorId,
        sourceUrl: sourceUrl,
        openingVariantId: openingVariantId || undefined
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Chat request failed');
        return response.json();
      })
      .then(function (data) {
        if (typing) { typing.remove(); typing = null; }
        if (data.conversationId) {
          conversationId = data.conversationId;
          window.localStorage.setItem('spiritAiConversationId', conversationId);
        }
        var answer = data.answer || 'I can help you choose a crystal. What intention are you shopping for?';
        appendMessage('assistant', answer);
        appendProducts(data.products || []);
        track('message_sent', { productCount: (data.products || []).length });
      })
      .catch(function () {
        if (typing) { typing.remove(); typing = null; }
        appendMessage('assistant', 'I had trouble connecting for a moment. Please try again.');
      })
      .finally(function () {
        root.classList.remove('is-loading');
      });
  }

  openBtn.addEventListener('click', function () { setOpen(panel.hidden); });
  closeBtn.addEventListener('click', function () { setOpen(false); });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    sendMessage(input.value);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      sendMessage(input.value);
    }
  });

  loadOpening();

  // Auto-open the full chat once per visitor, a little after they arrive.
  var autoOpened = window.localStorage.getItem('spiritAiAutoOpened') === '1';
  if (!autoOpened) {
    var openDelay = parseInt(root.getAttribute('data-auto-open-delay'), 10);
    if (isNaN(openDelay)) openDelay = 15000;
    window.setTimeout(function () {
      // Don't fight the offer pop-up if it's currently showing.
      if (window.__smOfferOpen) return;
      try { window.localStorage.setItem('spiritAiAutoOpened', '1'); } catch (e) {}
      if (!root.classList.contains('is-open')) {
        setOpen(true);
        track('auto_opened', {});
      }
    }, openDelay);
  }
})();
